export default function ({ app }, inject) {
    inject('emailTracker', {
        getEmail,
        setEmail,
    })

    function getEmail() {
        const email = app.$clientCookies.get('customerEmail')

        if (email) setEmail(email)
        return email || undefined
    }

    function setEmail(email) {
        const currentEmail = app.$clientCookies.get('customerEmail')
        app.$clientCookies.set('customerEmail', email, {
            expires: 3650, // 10 years
            secure: process.env.NODE_ENV === 'production',
        })
        if (email !== currentEmail) {
            app.$uiEvents.$emit('emailSet')
        }
    }
}
